import MAccordion from './MAccordion.vue';

MAccordion.install = (app) => {
  app.component('MAccordion', MAccordion);
};

export { MAccordion };
